import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getGroups } from '../services';
import { GROUPS_QUERY_KEY } from '../constants';
import { GroupApiResponse } from '../types/GroupApiResponse';

function useQueryGroups(): UseQueryResult<GroupApiResponse[]> {
  return useQuery([GROUPS_QUERY_KEY], getGroups);
}

export default useQueryGroups;
